import { getWorkOsClientId } from "./config";

/**
 * WorkOS Dashboard → Authentication → Features → JWT Template.
 * `aud` must equal WORKOS_CLIENT_ID / VITE_WORKOS_CLIENT_ID for Convex validation.
 * After saving, every user must sign out and sign in again.
 */
export function workOsJwtTemplateJson(clientId = getWorkOsClientId() ?? ""): string {
  const aud = clientId.trim() || "client_YOUR_WORKOS_CLIENT_ID";
  return `{
  "aud": "${aud}",
  "email": {{ user.email }},
  "email_verified": {{ user.email_verified }},
  "name": "{{ user.first_name }} {{ user.last_name }}",
  "picture": {{ user.profile_picture_url }}
}`;
}

export const WORKOS_JWT_TEMPLATE_DASHBOARD =
  "https://dashboard.workos.com/environment/authentication/features";
